export enum RoutePath {
  ADMIN = '/super-secret-admin-page',
  APP_LINK_REDIRECT = '/redirect',
  TIMEOUT = '/timedout',
  LOGIN = '/login',
  LOGOUT = '/logout',
  PAGE_NOT_FOUND = '/pageNotFound',
  EAQ_STUDENT_STUDY = '/eaq-student-study',
  EAQ_STUDENT_TOPIC_REPORT = '/eaq-student-topic-report',
  EAQ_STUDENT_PERFORMANCE_DETAILS = '/eaq-student-performance-details',
  SUPPORT = '/support',
  HELP = '/help',
  ASSESSMENT_START = '/assessment-start',
}

export const ServicePath = {
  loginPath: '/login-service/login',
  tokenServicePath: '/token-service',
  userServicePath: '/apiv1/eolsUser/list',
};

export const AppConstants = {
  APP_ID: 'STUDENT_STUDY',
  IDLE_TIMEOUT: 1000 * 60 * 60 * 6,
  PENDO_API_KEY: '94bb3f52-df30-4f69-4ec8-dceb6bffffbe'
};
